export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8513.c5761ed3.jpg";